export default [
  {
    path: '/humor',
    component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages'),
    children: [
      {
        path: '/',
        name: 'Humor',
        component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages/Humor'),
      },
      {
        path: 'list-moods',
        name: 'ListMoods',
        component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages/ListMoods')
      },
      {
        path: 'register',
        name: 'RegisterHumor',
        component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages/RegisterHumor')
      },
      {
        path: ':id/edit',
        name: 'EditHumor',
        component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages/RegisterHumor')
      },
      {
        path: 'register-questions',
        name: 'RegisterHumorQuestions',
        component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages/RegisterHumorQuestions')
      },
      {
        path: 'edit-questions',
        name: 'EditHumorQuestions',
        component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages/RegisterHumorQuestions')
      },
      {
        path: 'list-questions',
        name: 'ListHumorQuestions',
        component: () => import(/* webpackChunkName: "humor" */ '@/views/Humor/pages/ListHumorQuestions')
      },
    ],
  },
]
